/* ============================================================
   BT · COLLECTIE — filteren, sorteren en kleurwissel
   Werkt volledig client-side op de producten die op de pagina
   staan. Schrijft de keuze in de URL (?c=... &s=...) zodat een
   gefilterde weergave deelbaar is en terug-navigeren klopt.
   ============================================================ */
(function () {
  'use strict';

  var PARAM_CAT = 'c';
  var PARAM_SORT = 's';

  function txt(el, value) { if (el) el.textContent = value; }

  function terms(card) {
    return (card.getAttribute('data-btc-terms') || '').split('|').filter(Boolean);
  }

  function matches(card, want) {
    if (!want) return true;
    var have = terms(card);
    var list = want.split(',');
    for (var i = 0; i < list.length; i++) {
      var w = list[i].trim();
      if (!w) continue;
      for (var j = 0; j < have.length; j++) {
        if (have[j] === w || have[j].indexOf(w) !== -1 || w.indexOf(have[j]) !== -1) return true;
      }
    }
    return false;
  }

  var SORTERS = {
    'manual':     function (a, b) { return a.pos - b.pos; },
    'price-asc':  function (a, b) { return a.price - b.price || a.pos - b.pos; },
    'price-desc': function (a, b) { return b.price - a.price || a.pos - b.pos; },
    'date-desc':  function (a, b) { return b.date - a.date || a.pos - b.pos; },
    'date-asc':   function (a, b) { return a.date - b.date || a.pos - b.pos; },
    'title-asc':  function (a, b) { return a.title.localeCompare(b.title); },
    'title-desc': function (a, b) { return b.title.localeCompare(a.title); }
  };

  function init(root) {
    if (!root || root.getAttribute('data-btc-ready') === '1') return;
    root.setAttribute('data-btc-ready', '1');

    var grid     = root.querySelector('[data-btc-grid]');
    var sortEl   = root.querySelector('[data-btc-sort]');
    var countEl  = root.querySelector('[data-btc-count]');
    var emptyEl  = root.querySelector('[data-btc-empty]');
    var resetEl  = root.querySelector('[data-btc-reset]');
    var pills    = [].slice.call(root.querySelectorAll('[data-btc-filter]'));
    if (!grid) return;

    var cards = [].slice.call(grid.querySelectorAll('[data-btc-card]'));
    var one   = countEl && countEl.getAttribute('data-label-one')  || 'product';
    var many  = countEl && countEl.getAttribute('data-label-many') || 'products';
    var paged = root.getAttribute('data-btc-paged') === '1';

    var meta = cards.map(function (card, i) {
      return {
        el: card,
        pos: i,
        price: parseInt(card.getAttribute('data-btc-price') || '0', 10),
        date: parseInt(card.getAttribute('data-btc-date') || '0', 10),
        title: (card.getAttribute('data-btc-title') || '').toLowerCase()
      };
    });

    var state = { cat: '', sort: (sortEl && sortEl.value) || 'manual' };

    /* ---- tellers per filter: lege categorieën verbergen ---- */
    if (root.getAttribute('data-btc-hide-empty') === '1' && !paged) {
      pills.forEach(function (pill) {
        var want = pill.getAttribute('data-btc-filter');
        if (!want) return;
        var n = cards.filter(function (c) { return matches(c, want); }).length;
        var nEl = pill.querySelector('[data-btc-pill-count]');
        if (nEl) txt(nEl, String(n));
        if (n === 0) pill.hidden = true;
      });
    } else {
      pills.forEach(function (pill) {
        var want = pill.getAttribute('data-btc-filter');
        var nEl = pill.querySelector('[data-btc-pill-count]');
        if (!nEl) return;
        txt(nEl, String(want ? cards.filter(function (c) { return matches(c, want); }).length : cards.length));
      });
    }

    function apply(push) {
      var visible = [];
      meta.forEach(function (m) {
        var ok = matches(m.el, state.cat);
        m.el.hidden = !ok;
        if (ok) visible.push(m);
      });

      var sorter = SORTERS[state.sort] || SORTERS.manual;
      visible.slice().sort(sorter).forEach(function (m) { grid.appendChild(m.el); });

      pills.forEach(function (p) {
        var on = (p.getAttribute('data-btc-filter') || '') === state.cat;
        p.classList.toggle('is-active', on);
        if (p.tagName === 'BUTTON') p.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      if (countEl) txt(countEl, visible.length + ' ' + (visible.length === 1 ? one : many));
      if (emptyEl) emptyEl.classList.toggle('is-visible', visible.length === 0);

      if (push && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        if (state.cat) { url.searchParams.set(PARAM_CAT, state.cat); } else { url.searchParams.delete(PARAM_CAT); }
        if (state.sort && state.sort !== 'manual') { url.searchParams.set(PARAM_SORT, state.sort); } else { url.searchParams.delete(PARAM_SORT); }
        window.history.replaceState({}, '', url.toString());
      }
    }

    pills.forEach(function (pill) {
      if (pill.tagName !== 'BUTTON') return;
      pill.addEventListener('click', function () {
        state.cat = pill.getAttribute('data-btc-filter') || '';
        apply(true);
      });
    });

    if (sortEl) {
      sortEl.addEventListener('change', function () { state.sort = sortEl.value; apply(true); });
    }
    if (resetEl) {
      resetEl.addEventListener('click', function (e) {
        e.preventDefault();
        state.cat = '';
        if (sortEl) { sortEl.value = 'manual'; state.sort = 'manual'; }
        apply(true);
      });
    }

    /* ---- beginstand uit de URL ---- */
    try {
      var q = new URL(window.location.href).searchParams;
      var c = q.get(PARAM_CAT);
      var s = q.get(PARAM_SORT);
      if (c && pills.some(function (p) { return p.getAttribute('data-btc-filter') === c; })) state.cat = c;
      if (s && SORTERS[s]) { state.sort = s; if (sortEl) sortEl.value = s; }
    } catch (_) {}

    apply(false);
    initSwatches(root);
  }

  /* ---- kleurstalen op de kaart ---- */
  function initSwatches(root) {
    root.addEventListener('click', function (e) {
      var sw = e.target.closest ? e.target.closest('[data-btc-swatch]') : null;
      if (!sw || !root.contains(sw)) return;
      e.preventDefault();
      pick(sw);
    });
    root.addEventListener('mouseover', function (e) {
      var sw = e.target.closest ? e.target.closest('[data-btc-swatch]') : null;
      if (!sw || !root.contains(sw) || sw.getAttribute('data-btc-hover') !== '1') return;
      pick(sw);
    });
  }

  function pick(sw) {
    var card = sw.closest('[data-btc-card]');
    if (!card) return;

    card.querySelectorAll('[data-btc-swatch]').forEach(function (s) {
      var on = s === sw;
      s.classList.toggle('is-active', on);
      s.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    var img = card.querySelector('[data-btc-main-img]');
    var src = sw.getAttribute('data-btc-img');
    if (img && src) {
      img.setAttribute('src', src);
      var set = sw.getAttribute('data-btc-srcset');
      if (set) { img.setAttribute('srcset', set); } else { img.removeAttribute('srcset'); }
      var alt = card.querySelector('[data-btc-alt-img]');
      if (alt) alt.remove();
      img.classList.remove('has-alt');
    }

    var variant = sw.getAttribute('data-btc-variant');
    var base = card.getAttribute('data-btc-url');
    if (variant && base) {
      var href = base + (base.indexOf('?') === -1 ? '?' : '&') + 'variant=' + variant;
      card.querySelectorAll('[data-btc-link]').forEach(function (a) { a.setAttribute('href', href); });
    }
  }

  function boot() {
    document.querySelectorAll('[data-btc-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector ? e.target.querySelector('[data-btc-root]') : null;
    if (r) init(r);
  });
})();
